import { MdSearch } from 'react-icons/md'

import { DatePickerFormComponent } from '@/modules/shared/components/date-picker-form.component'
import { Button } from '@/modules/shared/components/ui/button'
import { Form } from '@/modules/shared/components/ui/form'

import {
  type SearchFormPeriodData,
  useSearchFormReportPeriod,
} from '../hooks/use-search-form-report-period.hook'

interface ISearchFormReportPeriodProps {
  reportType: 'Client' | 'Product' | 'Commission'
}

export function SearchFormReportPeriod({
  reportType,
}: ISearchFormReportPeriodProps) {
  const { handleLoadReport, form } = useSearchFormReportPeriod({
    reportType,
  })

  return (
    <Form {...form}>
      <form
        onSubmit={form.handleSubmit(handleLoadReport)}
        className="flex-1 flex items-end space-x-2 flex-row"
      >
        <DatePickerFormComponent<SearchFormPeriodData>
          control={form.control}
          name="dtStart"
          label="Data Inicio"
        />
        <DatePickerFormComponent<SearchFormPeriodData>
          control={form.control}
          name="dtEnd"
          label="Data Fim"
        />
        <Button variant="outline" type="submit">
          <MdSearch size={24} />
        </Button>
      </form>
    </Form>
  )
}
